<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-5_update-flightsroutes-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-5_update-flightsroutes-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.60289625420932;"
    data-aspect-ratio="0.603"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-5_update-flightsroutes-xs-img"
      class="g-post-5_update-flightsroutes-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-5_update-flightsroutes-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.8562%;margin-top:-9.6px;left:11.1133%;width:114px;"
    >
      <p class="g-pstyle0">ATC boundaries</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs"
      style="top:3.1058%;left:54.9358%;width:43.3333%;"
    >
      <p class="g-pstyle1">
        Closed, partially closed, or intermittently closed airspaces
      </p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:20.2027%;margin-top:-18.6px;left:14.4499%;width:108px;"
    >
      <p class="g-pstyle0">Alternative</p>
      <p class="g-pstyle0">flight corridors</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.0993%;margin-top:-9.5px;left:9.3942%;width:67px;"
    >
      <p class="g-pstyle2">TURKEY</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.6646%;margin-top:-18.6px;left:57.2961%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle3">Caspian</p>
      <p class="g-pstyle3">Sea</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.5109%;margin-top:-9.6px;left:59.2022%;width:63px;"
    >
      <p class="g-pstyle4">Tehran</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.8111%;margin-top:-9.5px;left:28.1718%;width:51px;"
    >
      <p class="g-pstyle5">IRAQ</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.4651%;margin-top:-9.5px;left:67.2005%;width:51px;"
    >
      <p class="g-pstyle6">IRAN</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.5805%;margin-top:-9.5px;left:34.575%;width:67px;"
    >
      <p class="g-pstyle5">KUWAIT</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:66.6074%;margin-top:-9.6px;left:50.236%;width:54px;"
    >
      <p class="g-pstyle4">Doha</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.1479%;margin-top:-9.5px;left:21.7735%;width:103px;"
    >
      <p class="g-pstyle2">SAUDI ARABIA</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.3382%;margin-top:-9.6px;left:67.1757%;width:58px;"
    >
      <p class="g-pstyle4">Dubai</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.1748%;margin-top:-9.6px;left:34.0007%;width:62px;"
    >
      <p class="g-pstyle7">Riyadh</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.5326%;margin-top:-9.5px;left:61.0492%;width:46px;"
    >
      <p class="g-pstyle6">UAE</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.3672%;margin-top:-9.6px;left:11.788%;width:63px;"
    >
      <p class="g-pstyle7">Jeddah</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.4654%;margin-top:-9.5px;left:72.8202%;width:58px;"
    >
      <p class="g-pstyle2">OMAN</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);transform-origin: 50% 37.571953672238%;-webkit-transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);-webkit-transform-origin: 50% 37.571953672238%;-ms-transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);-ms-transform-origin: 50% 37.571953672238%;top:82.1366%;margin-top:-9.6px;left:22.0384%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle3">Red Sea</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.6078%;margin-top:-9.6px;left:74.364%;width:92px;"
    >
      <p class="g-pstyle8">Arabian Sea</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.6099%;margin-top:-9.5px;left:41.9326%;width:62px;"
    >
      <p class="g-pstyle2">YEMEN</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:91.6441%;margin-top:-5.6px;left:87.2575%;width:45px;"
    >
      <p class="g-pstyle9">500km</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-5_update-flightsroutes-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.78812456655787;"
    data-aspect-ratio="0.788"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-5_update-flightsroutes-sm-img"
      class="g-post-5_update-flightsroutes-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-5_update-flightsroutes-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.1077%;margin-top:-9.6px;left:8.8331%;width:114px;"
    >
      <p class="g-pstyle0">ATC boundaries</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs"
      style="top:2.6271%;left:39.6384%;width:28.0392%;"
    >
      <p class="g-pstyle1">
        Closed, partially closed, or intermittently closed airspaces
      </p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.4985%;margin-top:-18.6px;left:81.3842%;width:108px;"
    >
      <p class="g-pstyle0">Alternative</p>
      <p class="g-pstyle0">flight corridors</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.3159%;margin-top:-9.6px;left:11.1581%;width:77px;"
    >
      <p class="g-pstyle2">Black Sea</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.4424%;margin-top:-18.6px;left:61.8045%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle3">Caspian</p>
      <p class="g-pstyle3">Sea</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.5905%;margin-top:-9.5px;left:15.8298%;width:67px;"
    >
      <p class="g-pstyle4">TURKEY</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.4871%;margin-top:-9.6px;left:63.4078%;width:63px;"
    >
      <p class="g-pstyle5">Tehran</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.6506%;margin-top:-9.6px;left:22.7144%;width:59px;"
    >
      <p class="g-pstyle6">SYRIA</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.0593%;margin-top:-9.6px;left:70.9873%;width:53px;"
    >
      <p class="g-pstyle0">IRAN</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.6774%;margin-top:-9.6px;left:6.6844%;width:67px;"
    >
      <p class="g-pstyle5">Tel Aviv</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.9865%;margin-top:-9.6px;left:40.0006%;width:53px;"
    >
      <p class="g-pstyle6">IRAQ</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:49.5407%;margin-top:-9.6px;left:8.7306%;width:66px;"
    >
      <p class="g-pstyle0">ISRAEL</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.2496%;margin-top:-9.6px;left:42.4795%;width:71px;"
    >
      <p class="g-pstyle6">KUWAIT</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.3313%;margin-top:-9.6px;left:3.7574%;width:52px;"
    >
      <p class="g-pstyle7">Cairo</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.5216%;margin-top:-9.6px;left:66.533%;width:58px;"
    >
      <p class="g-pstyle5">Dubai</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.4488%;margin-top:-9.6px;left:42.6626%;width:62px;"
    >
      <p class="g-pstyle7">Riyadh</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.5306%;margin-top:-9.6px;left:54.8323%;width:54px;"
    >
      <p class="g-pstyle5">Doha</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.4514%;margin-top:-9.5px;left:4.1532%;width:59px;"
    >
      <p class="g-pstyle4">EGYPT</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.3122%;margin-top:-9.6px;left:64.9728%;width:48px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.3301%;margin-top:-9.6px;left:24.4062%;width:63px;"
    >
      <p class="g-pstyle7">Jeddah</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.5599%;margin-top:-9.5px;left:41.5935%;width:103px;"
    >
      <p class="g-pstyle4">SAUDI ARABIA</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.7145%;margin-top:-9.5px;left:75.7332%;width:58px;"
    >
      <p class="g-pstyle4">OMAN</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);transform-origin: 50% 37.571953672238%;-webkit-transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);-webkit-transform-origin: 50% 37.571953672238%;-ms-transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);-ms-transform-origin: 50% 37.571953672238%;top:81.9929%;margin-top:-9.6px;left:30.8538%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle3">Red Sea</p>
    </div>
    <div
      id="g-ai1-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.5319%;margin-top:-9.5px;left:6.5564%;width:63px;"
    >
      <p class="g-pstyle4">SUDAN</p>
    </div>
    <div
      id="g-ai1-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.7018%;margin-top:-9.6px;left:81.9102%;width:92px;"
    >
      <p class="g-pstyle2">Arabian Sea</p>
    </div>
    <div
      id="g-ai1-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.2407%;margin-top:-9.5px;left:48.7197%;width:62px;"
    >
      <p class="g-pstyle4">YEMEN</p>
    </div>
    <div
      id="g-ai1-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:91.9328%;margin-top:-7.9px;left:89.4612%;width:55px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-5_update-flightsroutes-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.04224291990883;"
    data-aspect-ratio="1.042"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post-5_update-flightsroutes-md-img"
      class="g-post-5_update-flightsroutes-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-5_update-flightsroutes-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.1976%;margin-top:-9.6px;left:6.0886%;width:114px;"
    >
      <p class="g-pstyle0">ATC boundaries</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs"
      style="top:2.6846%;left:29.8927%;width:31.0606%;"
    >
      <p class="g-pstyle1">
        Closed, partially closed, or intermittently closed airspaces
      </p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.6188%;margin-top:-18.6px;left:70.256%;width:108px;"
    >
      <p class="g-pstyle0">Alternative</p>
      <p class="g-pstyle0">flight corridors</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.3042%;margin-top:-9.6px;left:19.8436%;width:77px;"
    >
      <p class="g-pstyle2">Black Sea</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.41%;margin-top:-9.6px;left:7.6509%;width:71px;"
    >
      <p class="g-pstyle3">Istanbul</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.6741%;margin-top:-18.6px;left:58.448%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle4">Caspian</p>
      <p class="g-pstyle4">Sea</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.8254%;margin-top:-9.5px;left:22.922%;width:67px;"
    >
      <p class="g-pstyle5">TURKEY</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.3598%;margin-top:-9.6px;left:28.7734%;width:59px;"
    >
      <p class="g-pstyle6">SYRIA</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.3598%;margin-top:-9.6px;left:59.8198%;width:63px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.9919%;margin-top:-9.6px;left:3.6516%;width:129px;"
    >
      <p class="g-pstyle2">Mediterranean Sea</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.1433%;margin-top:-9.5px;left:82.9631%;width:103px;"
    >
      <p class="g-pstyle5">AFGHANISTAN</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.3081%;margin-top:-9.6px;left:15.8551%;width:67px;"
    >
      <p class="g-pstyle3">Tel Aviv</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.624%;margin-top:-9.6px;left:39.2078%;width:53px;"
    >
      <p class="g-pstyle6">IRAQ</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.4664%;margin-top:-9.6px;left:63.0192%;width:53px;"
    >
      <p class="g-pstyle0">IRAN</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.4664%;margin-top:-9.6px;left:16.2404%;width:66px;"
    >
      <p class="g-pstyle0">ISRAEL</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.8881%;margin-top:-9.6px;left:42.3192%;width:71px;"
    >
      <p class="g-pstyle6">KUWAIT</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:52.046%;margin-top:-9.6px;left:11.0687%;width:52px;"
    >
      <p class="g-pstyle7">Cairo</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.9348%;margin-top:-9.5px;left:87.5858%;width:77px;"
    >
      <p class="g-pstyle5">PAKISTAN</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.5209%;margin-top:-9.6px;left:62.1017%;width:58px;"
    >
      <p class="g-pstyle3">Dubai</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.4684%;margin-top:-9.6px;left:43.6565%;width:62px;"
    >
      <p class="g-pstyle7">Riyadh</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.0935%;margin-top:-9.5px;left:6.5912%;width:59px;"
    >
      <p class="g-pstyle5">EGYPT</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.5738%;margin-top:-9.6px;left:53.0602%;width:54px;"
    >
      <p class="g-pstyle3">Doha</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.048%;margin-top:-9.6px;left:61.0291%;width:48px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai2-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.5221%;margin-top:-9.6px;left:29.5493%;width:63px;"
    >
      <p class="g-pstyle7">Jeddah</p>
    </div>
    <div
      id="g-ai2-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.6735%;margin-top:-9.5px;left:41.2358%;width:103px;"
    >
      <p class="g-pstyle5">SAUDI ARABIA</p>
    </div>
    <div
      id="g-ai2-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.0947%;margin-top:-9.5px;left:68.4138%;width:58px;"
    >
      <p class="g-pstyle5">OMAN</p>
    </div>
    <div
      id="g-ai2-27"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);transform-origin: 50% 37.571953672238%;-webkit-transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);-webkit-transform-origin: 50% 37.571953672238%;-ms-transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);-ms-transform-origin: 50% 37.571953672238%;top:81.4183%;margin-top:-9.6px;left:34.5315%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle4">Red Sea</p>
    </div>
    <div
      id="g-ai2-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.833%;margin-top:-9.5px;left:12.0357%;width:63px;"
    >
      <p class="g-pstyle5">SUDAN</p>
    </div>
    <div
      id="g-ai2-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.8924%;margin-top:-9.6px;left:84.0825%;width:92px;"
    >
      <p class="g-pstyle2">Arabian Sea</p>
    </div>
    <div
      id="g-ai2-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.7809%;margin-top:-9.5px;left:48.3369%;width:62px;"
    >
      <p class="g-pstyle5">YEMEN</p>
    </div>
    <div
      id="g-ai2-31"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:91.5757%;margin-top:-7.9px;left:13.8846%;width:55px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post-5_update-flightsroutes-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.28570071493076;"
    data-aspect-ratio="1.286"
    data-min-width="930"
  >
    <div
      id="g-post-5_update-flightsroutes-lg-img"
      class="g-post-5_update-flightsroutes-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-5_update-flightsroutes-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs"
      style="top:2.9032%;left:24.8165%;width:22.043%;"
    >
      <p class="g-pstyle0">
        Closed, partially closed, or intermittently closed airspaces
      </p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.2278%;margin-top:-9.6px;left:7.9233%;width:114px;"
    >
      <p class="g-pstyle1">ATC boundaries</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.472%;margin-top:-18.6px;left:53.4614%;width:108px;"
    >
      <p class="g-pstyle1">Alternative</p>
      <p class="g-pstyle1">flight corridors</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.5871%;margin-top:-9.6px;left:26.8732%;width:77px;"
    >
      <p class="g-pstyle2">Black Sea</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.2461%;margin-top:-9.6px;left:9.367%;width:71px;"
    >
      <p class="g-pstyle3">Istanbul</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.185%;margin-top:-9.5px;left:23.4609%;width:67px;"
    >
      <p class="g-pstyle4">TURKEY</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:20.9557%;margin-top:-9.6px;left:50.4141%;width:92px;"
    >
      <p class="g-pstyle2">Caspian Sea</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.2183%;margin-top:-9.6px;left:54.9382%;width:63px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.1537%;margin-top:-9.6px;left:29.14%;width:59px;"
    >
      <p class="g-pstyle5">SYRIA</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.7482%;margin-top:-9.6px;left:5.4093%;width:129px;"
    >
      <p class="g-pstyle2">Mediterranean Sea</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.8807%;margin-top:-9.5px;left:75.8402%;width:103px;"
    >
      <p class="g-pstyle4">AFGHANISTAN</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.0984%;margin-top:-9.6px;left:36.602%;width:53px;"
    >
      <p class="g-pstyle5">IRAQ</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.7896%;margin-top:-9.6px;left:19.1581%;width:67px;"
    >
      <p class="g-pstyle3">Tel Aviv</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.1721%;margin-top:-9.6px;left:58.0228%;width:53px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.6605%;margin-top:-9.6px;left:19.228%;width:66px;"
    >
      <p class="g-pstyle1">ISRAEL</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.6697%;margin-top:-9.6px;left:42.2477%;width:71px;"
    >
      <p class="g-pstyle5">KUWAIT</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.0844%;margin-top:-9.6px;left:13.5225%;width:52px;"
    >
      <p class="g-pstyle6">Cairo</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:52.6086%;margin-top:-9.5px;left:78.5102%;width:77px;"
    >
      <p class="g-pstyle4">PAKISTAN</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.3413%;margin-top:-9.5px;left:11.6678%;width:59px;"
    >
      <p class="g-pstyle4">EGYPT</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.3147%;margin-top:-9.6px;left:57.677%;width:58px;"
    >
      <p class="g-pstyle3">Dubai</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.5912%;margin-top:-9.6px;left:42.1444%;width:62px;"
    >
      <p class="g-pstyle6">Riyadh</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.559%;margin-top:-9.6px;left:49.6323%;width:54px;"
    >
      <p class="g-pstyle3">Doha</p>
    </div>
    <div
      id="g-ai3-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.1477%;margin-top:-9.5px;left:94.0923%;width:54px;"
    >
      <p class="g-pstyle4">INDIA</p>
    </div>
    <div
      id="g-ai3-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.2594%;margin-top:-9.6px;left:57.1894%;width:48px;"
    >
      <p class="g-pstyle1">UAE</p>
    </div>
    <div
      id="g-ai3-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.8215%;margin-top:-9.6px;left:32.1329%;width:63px;"
    >
      <p class="g-pstyle6">Jeddah</p>
    </div>
    <div
      id="g-ai3-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.9541%;margin-top:-9.5px;left:62.8689%;width:58px;"
    >
      <p class="g-pstyle4">OMAN</p>
    </div>
    <div
      id="g-ai3-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.8895%;margin-top:-9.5px;left:40.0896%;width:103px;"
    >
      <p class="g-pstyle4">SAUDI ARABIA</p>
    </div>
    <div
      id="g-ai3-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.0427%;margin-top:-9.6px;left:76.3292%;width:92px;"
    >
      <p class="g-pstyle2">Arabian Sea</p>
    </div>
    <div
      id="g-ai3-29"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);transform-origin: 50% 37.571953672238%;-webkit-transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);-webkit-transform-origin: 50% 37.571953672238%;-ms-transform: matrix(0.7783,0.6279,-0.6279,0.7783,0,0);-ms-transform-origin: 50% 37.571953672238%;top:81.508%;margin-top:-9.6px;left:32.9211%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle7">Red Sea</p>
    </div>
    <div
      id="g-ai3-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.0553%;margin-top:-9.5px;left:47.6032%;width:62px;"
    >
      <p class="g-pstyle4">YEMEN</p>
    </div>
    <div
      id="g-ai3-31"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.8525%;margin-top:-9.5px;left:13.0893%;width:63px;"
    >
      <p class="g-pstyle4">SUDAN</p>
    </div>
    <div
      id="g-ai3-32"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:90.0736%;margin-top:-9.5px;left:9.7822%;width:61px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-04 10:59 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-03-04 10:59 -->
<!-- ai file: post-5_update-flightsroutes.ai -->
<style lang="scss">
  #g-post-5_update-flightsroutes-box {
    container-type: inline-size;
    container-name: g-post-5_update-flightsroutes-box;
  }
  #g-post-5_update-flightsroutes-box,
  #g-post-5_update-flightsroutes-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-5_update-flightsroutes-box p {
    margin: 0;
  }
  #g-post-5_update-flightsroutes-box .g-aiAbs {
    position: absolute;
  }
  #g-post-5_update-flightsroutes-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-5_update-flightsroutes-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-5_update-flightsroutes-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-5_update-flightsroutes-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-5_update-flightsroutes-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-5_update-flightsroutes-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-5_update-flightsroutes-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post-5_update-flightsroutes-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post-5_update-flightsroutes-lg {
        display: block !important;
      }
    }
  }
  #g-post-5_update-flightsroutes-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-5_update-flightsroutes-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle1 {
    font-weight: 400;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle2 {
    font-weight: 300;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    font-size: 13px;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle3 {
    font-weight: 400;
    font-style: italic;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle4 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle5 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 13px;
    color: rgb(102, 102, 102);
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle6 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 13px;
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle7 {
    font-weight: 300;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle8 {
    font-weight: 400;
    font-style: italic;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-xs .g-pstyle9 {
    font-weight: 300;
    line-height: 11px;
    height: 11px;
    padding-bottom: 5px;
    font-size: 8px;
  }
  #g-post-5_update-flightsroutes-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-5_update-flightsroutes-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle1 {
    font-weight: 400;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle2 {
    font-weight: 400;
    font-style: italic;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle3 {
    font-weight: 400;
    font-style: italic;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle4 {
    font-weight: 300;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    font-size: 13px;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle5 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle6 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    color: rgb(102, 102, 102);
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle7 {
    font-weight: 300;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-sm .g-pstyle8 {
    font-weight: 300;
    line-height: 15px;
    height: 15px;
    padding-bottom: 8px;
    font-size: 11px;
  }
  #g-post-5_update-flightsroutes-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-5_update-flightsroutes-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post-5_update-flightsroutes-md .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-md .g-pstyle1 {
    font-weight: 400;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-md .g-pstyle2 {
    font-weight: 400;
    font-style: italic;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-md .g-pstyle3 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-md .g-pstyle4 {
    font-weight: 400;
    font-style: italic;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-md .g-pstyle5 {
    font-weight: 300;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    font-size: 13px;
    color: rgb(199, 200, 202);
  }
  #g-post-5_update-flightsroutes-md .g-pstyle6 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    color: rgb(102, 102, 102);
  }
  #g-post-5_update-flightsroutes-md .g-pstyle7 {
    font-weight: 300;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-md .g-pstyle8 {
    font-weight: 300;
    line-height: 15px;
    height: 15px;
    padding-bottom: 8px;
    font-size: 11px;
  }
  #g-post-5_update-flightsroutes-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-5_update-flightsroutes-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    mix-blend-mode: normal;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 13px;
    text-align: left;
    color: rgb(199, 200, 202);
    text-transform: none;
    padding-top: 0;
    font-style: normal;
    position: static;
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle0 {
    font-weight: 400;
    padding-bottom: 9px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle2 {
    font-weight: 400;
    font-style: italic;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    font-size: 14px;
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle3 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle4 {
    font-weight: 300;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle5 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    color: rgb(102, 102, 102);
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle6 {
    font-weight: 300;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle7 {
    font-weight: 400;
    font-style: italic;
    height: 18px;
    mix-blend-mode: multiply;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
  }
  #g-post-5_update-flightsroutes-lg .g-pstyle8 {
    font-weight: 300;
    height: 18px;
    padding-bottom: 9px;
    color: rgb(64, 64, 64);
  }

  /* Custom CSS */
</style>
